import IcSuggestion from './IcSuggestion'
export default IcSuggestion
